import * as React from 'react'

import { Box, Link, Section, Text } from '@factorialco/deprecated-design-system'
import { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/Inputs/Text'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { linkedInCompanyUrl, validLinkedInId } from 'modules/app_store/lib/linkedin'
import atsCompanies from 'modules/ats/store/collections/atsCompanies'

class Form extends FactorialForm {
  constructor(values: Record<string, string>) {
    super(values, {
      linkedin_id: 'string',
    })
  }

  get isValid() {
    return validLinkedInId(this.get('linkedin_id').value)
  }
}

const LinkedinLimitedListingsSettings = () => {
  useAsyncData(() => atsCompanies.fetch(), [])
  const atsCompany = atsCompanies.current
  const form: Form = React.useRef(new Form({})).current

  useEffect(() => {
    if (atsCompany) {
      form.setValues(atsCompany.toJS())
      form.cleanAll()
    }
  }, [!!atsCompany]) // eslint-disable-line react-hooks/exhaustive-deps

  const { running, performAction } = useAsyncAction(() => form.save(atsCompany!))
  const checkIdUrl = linkedInCompanyUrl(form.get('linkedin_id').value)

  return (
    <Section.Form
      illustration="settings"
      title={i18n.t(
        'app_store_v2.app_integrations.linkedin_limited_listings.settings.company_id.title'
      )}
      description={i18n.t(
        'app_store_v2.app_integrations.linkedin_limited_listings.settings.company_id.description'
      )}
      onSubmit={performAction}
      submitLabel={i18n.t('common.submit')}
      disabled={running || !form.isValid}
      isDirty={form.isDirty}
    >
      <TextField
        mandatory
        label={i18n.t(
          'app_store_v2.app_integrations.linkedin_limited_listings.settings.company_id.linkedin_id'
        )}
        field={form.get('linkedin_id')}
      />

      {checkIdUrl && (
        <Box gap="s16">
          <Text.Normal size="200">
            {i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id_info', {
              check_id: i18n.t(
                'app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id'
              ),
            })}
          </Text.Normal>
          <Link.Href href={checkIdUrl} target="_blank">
            {i18n.t('app_store_v2.app_integrations.linkedin_limited_listings.modal.check_id')}
          </Link.Href>
        </Box>
      )}
    </Section.Form>
  )
}

export default observer(LinkedinLimitedListingsSettings)
